// Styles
//import 'reset-css';
import "./index.scss";
import "./template/layout/layout.js";
import "./template/functions/components/components.js";
import "./template/functions/components/image_carousel_section/image_carousel_section.js";